import { render, staticRenderFns } from "./SeoReport.vue?vue&type=template&id=767d3a15"
import script from "./SeoReport.vue?vue&type=script&lang=js"
export * from "./SeoReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports